/**
 * Formats newsletter first-name values to title case before storage (e.g. "jamie seal" → "Jamie Seal").
 */
function formatNameToTitleCase(name) {
  const trimmed = name.trim().replace(/\s+/g, ' ');
  if (!trimmed) return '';

  return trimmed.split(' ').map(formatNamePartToTitleCase).join(' ');
}

function formatNamePartToTitleCase(part) {
  return part
    .split(/(-)/)
    .map((segment) => (segment === '-' ? segment : formatSegmentToTitleCase(segment)))
    .join('');
}

function formatSegmentToTitleCase(segment) {
  return segment
    .split(/(['\u2019])/)
    .map((piece) => {
      if (piece === "'" || piece === '\u2019') return piece;
      if (!piece) return piece;
      const lower = piece.toLocaleLowerCase('en-GB');
      return lower.charAt(0).toLocaleUpperCase('en-GB') + lower.slice(1);
    })
    .join('');
}

function formatNewsletterFirstNameInput(input) {
  if (!input?.value) return;
  input.value = formatNameToTitleCase(input.value);
}

function initNewsletterFirstNameFormatting(root = document) {
  root.querySelectorAll('form.newsletter-form:not([data-first-name-format])').forEach((form) => {
    const firstNameInput = form.querySelector('[name="contact[first_name]"]');
    if (!firstNameInput) return;

    form.setAttribute('data-first-name-format', '');

    firstNameInput.addEventListener('blur', () => {
      formatNewsletterFirstNameInput(firstNameInput);
    });

    form.addEventListener(
      'submit',
      () => {
        formatNewsletterFirstNameInput(firstNameInput);
      },
      { capture: true }
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initNewsletterFirstNameFormatting());
} else {
  initNewsletterFirstNameFormatting();
}

document.addEventListener('shopify:section:load', (event) => {
  initNewsletterFirstNameFormatting(event.target);
});
